import {BaseObservableForm} from "../../shared-library/forms/base-observable.form";
import {SavedSearchesParametersModel} from "../models/saved-searches-parameters.model";
import {Observable} from "rxjs";

import {AbstractControl, FormControl, FormGroup} from "@angular/forms";
import {map} from "rxjs/operators";
import {merge} from "lodash";
import _merge from "lodash/merge";

export class SavedSearchesForm extends BaseObservableForm<SavedSearchesParametersModel> {
    public static createForm(
        initialSearchParams: SavedSearchesParametersModel,
        emptySearchParams: SavedSearchesParametersModel
    ): SavedSearchesForm {
        const formGroup = new FormGroup({
            sortOption: new FormControl(initialSearchParams.sortOption),
            pageNumber: new FormControl(initialSearchParams.pageNumber),
            pageSize: new FormControl(initialSearchParams.pageSize)
        });

        return new SavedSearchesForm(formGroup, initialSearchParams, emptySearchParams);
    }

    public get instance(): FormGroup { return this.formInstance; }
    public get sortOption(): AbstractControl { return this.getFormControl("sortOption"); }
    public get pageNumber(): AbstractControl { return this.getFormControl("pageNumber"); }
    public get pageSize(): AbstractControl { return this.getFormControl("pageSize"); }
    protected constructor(
        formInstance: FormGroup,
        initialSearchParams: SavedSearchesParametersModel,
        private emptySearchParams: SavedSearchesParametersModel
    ) {
        super(formInstance, initialSearchParams);
    }
    protected bindOnChangeSubscription(): Observable<SavedSearchesParametersModel> {
        return merge(
            this.sortOption.valueChanges.pipe(map((sortOption: string) => ({
                sortOption: sortOption,
                pageNumber: 1
            }))),
            this.pageNumber.valueChanges.pipe(map((pageNumber: number) => ({
                pageNumber: pageNumber
            }))),
            this.pageSize.valueChanges.pipe(map((pageSize: number) => ({
                pageNumber: 1,
                pageSize: pageSize
            })))
        ).pipe(
            map(partialModel => this.getFormModel(partialModel))
        );
    }
    protected getFormModel(partialFormModel: any = {}): SavedSearchesParametersModel {
        return _merge(new SavedSearchesParametersModel(), super.getFormModel(partialFormModel));
    }

    public reset(): void {
        this.formInstance.patchValue(this.emptySearchParams, { emitEvent: false });
    }

}
